import { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EyeIcon from '../../icons/Eye.icon';
import EyeOffIcon from '../../icons/EyeOff.icon';
import { Input, InputProps } from './Input';

export type PasswordInputProps = Omit<InputProps, 'type' | 'endIcon'>;

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ ...props }, ref) => {
    const { t } = useTranslation('entry');
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword((prev) => !prev);
    };

    return (
      <Input
        {...props}
        ref={ref}
        type={showPassword ? 'text' : 'password'}
        endIcon={
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="flex items-center justify-center text-muted-foreground transition-colors hover:text-foreground focus:outline-none"
            tabIndex={-1}
            aria-label={showPassword ? t('hide_password') : t('show_password')}
          >
            {showPassword ? <EyeOffIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}
          </button>
        }
      />
    );
  },
);

PasswordInput.displayName = 'PasswordInput';
